import {useI18n} from '@shopify/react-i18n';
import {FooterHelp, Link} from '@shopify/polaris';
import {useUrl} from '@web-utilities/url';

export const FooterHelpLink = () => {
  const [i18n] = useI18n();
  const urlHelper = useUrl();
  const scope = ['FooterHelpLink'];

  return (
    <FooterHelp>
      {i18n.translate(
        'learnMore',
        {scope},
        {
          learnMoreLink: (
            <Link
              url={urlHelper.helpCenterUrl({
                locale: i18n.locale,
                path: 'manual/markets/languages',
              })}
              target="_blank"
            >
              {i18n.translate('learnMoreLink', {
                scope,
              })}
            </Link>
          ),
        },
      )}
    </FooterHelp>
  );
};
